import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import {
  LoginResponse,
} from '../user/api-rest/rest-user.service';
import { AuthStateService } from '../user/auth-state/auth-state.service';

@Injectable({
  providedIn: 'root',
})
export class JwtService {
  constructor(
    private authState: AuthStateService,
  ) {}

  getUserInfos(): LoginResponse {
    return JSON.parse(
      localStorage.getItem('userInfo') || '{}',
    ) as LoginResponse;
  }

  isAuthenticated(): boolean {
    return this.getUserInfos().isAuthenticated === true;
  }

  getPlatform(): number {
    return (
      this.authState.getAuth()?.platform ?? this.getUserInfos()?.platform ?? -1
    );
  }

  getPermissions(): string[] {
    return this.authState.getPermissions() ?? [];
  }

  hasPermission(permission: string): boolean {
    return this.getPermissions().includes(permission);
  }

  hasAnyPermission(permissions: string[]): boolean {
    return permissions.some((p) => this.getPermissions().includes(p));
  }

  isAdmin(): boolean {
    return this.authState.isAdmin();
  }

  getCurrentUserAuthorities(): Observable<string[]> {
    return this.authState
      .whenReady()
      .pipe(map(() => this.authState.getPermissions() ?? []));
  }

  hasRole(role: string): boolean {
    return this.getPermissions().includes(role);
  }

  hasAnyRole(roles: string[]): boolean {
    return roles.some((role) => this.getPermissions().includes(role));
  }
}
